import React from "react";

const UpcomingTripsBtn = () => {
  return (
    <>
      <div className="position-relative">
        <div className="container-fluid">
          <a href="#upcomingTrips" className="custom-ut-btn">
            Upcoming Trips
          </a>
        </div>
      </div>
    </>
  );
};

export default UpcomingTripsBtn;
